<div class="input-wrapper d-flex">
  @if (label !== '') {
<span class="dci-label">{{label}}</span>
}
  @if (type !== 'textarea') {
<input [type]="type" [maxLength]="maxLength" [value]="value ?? ''" (keyup)="onKeyUp($event)">
}
  @if (type === 'textarea') {
<textarea [maxLength]="maxLength" [value]="value ?? ''" (keyup)="onKeyUp($event)"></textarea>
}
</div>
<div class="input-length-desc-wrapper d-flex">
  @if (label !== '') {
<span class="dci-label"></span>
}
  <span class="length-desc">{{currLength}}/{{maxLength}}</span>
</div>
